import {TOption} from './TOption'

export const SKBDN_TYPES: TOption[] = [
  {value: '1', label: 'At Sight'},
  {value: '2', label: 'Usance'},
]
